/////////////////// ※주의: 루쿠쿠 편집 금지
/////////////////// ※warning: do not edit this file in lukuku

//  윌슨 퍼블리셔 전용 전역 JS 
//  wilson only publisher global js file
function publisherInitScrollReveal(options = {}) {
  const opts = {
      ...{
        scope: '.publisher-html',
        selector: '.reveal',
        distance: 80,
        duration: 1.25,
        ease: 'expo',
        wipeDuration: 1.3,
        wipeEase: 'power3.out',
        start: 'top 90%',
        end: 'bottom top',
        once: !0,
      },
      ...options,
    },
    scopeEl = document.querySelector(opts.scope);
  if (!scopeEl) return null;
  gsap.registerPlugin(ScrollTrigger);
  const directionMap = {
      reveal_l: {
        x: -opts.distance,
        y: 0,
      },
      reveal_b: {
        x: 0,
        y: opts.distance,
      },
      reveal_t: {
        x: 0,
        y: -opts.distance,
      },
      reveal_r: {
        x: opts.distance,
        y: 0,
      },
    },
    wipeMap = {
      reveal_wipe_l: {
        from: {
          clipPath: 'inset(0 100% 0 0)',
          autoAlpha: 1,
        },
        to: {
          clipPath: 'inset(0 0% 0 0)',
        },
        duration: opts.wipeDuration,
      },
      reveal_wipe_RTL: {
        from: {
          clipPath: 'inset(0 0 0 100%)',
        },
        to: {
          clipPath: 'inset(0 0 0 0%)',
          autoAlpha: 1,
        },
        duration: opts.wipeDuration,
      },
    },
    hide = (item) => {
      gsap.set(item, {
        autoAlpha: 0,
      });
    },
    animate = (item) => {
      const delay = parseFloat(item.dataset.delay) || 0,
        wipeKey = Object.keys(wipeMap).find((cls) => item.classList.contains(cls));
      if (wipeKey) {
        const { from, to, duration } = wipeMap[wipeKey];
        (gsap.set(item, from),
          gsap.to(item, {
            ...to,
            duration,
            ease: opts.wipeEase,
            delay,
          }));
        return;
      }
      const dirKey = Object.keys(directionMap).find((cls) => item.classList.contains(cls)),
        { x, y } = directionMap[dirKey] || directionMap.reveal_r;
      (gsap.set(item, {
        x,
        y,
      }),
        gsap.to(item, {
          autoAlpha: 1,
          x: 0,
          y: 0,
          delay,
          duration: opts.duration,
          ease: opts.ease,
        }));
    };
  return (
    gsap.utils.toArray(scopeEl.querySelectorAll(opts.selector)).forEach((item) => {
      (hide(item),
        ScrollTrigger.create({
          trigger: item,
          start: opts.start,
          end: opts.end,
          once: opts.once,
          onEnter: () => animate(item),
        }));
    }),
    {
      refresh: () => ScrollTrigger.refresh(),
    }
  );
}

function publisherInitSplitReveal(options = {}) {
  const opts = {
    ...{
      scope: '.publisher-html',
      selector: '.split',
      titleClass: 'split-title',
      descClass: 'split-desc',
      distance: '100%',
      stagger: 0.05,
      duration: 1,
      ease: 'power2.out',
      start: 'top 90%',
      once: true,
      mode: 'words', // 기본 split 단위
    },
    ...options,
  };

  const scopeEl = document.querySelector(opts.scope);
  if (!scopeEl) return null;

  gsap.registerPlugin(ScrollTrigger, SplitText);

  const VALID_MODES = ['words', 'lines', 'chars'];

  const presetMap = {
    [opts.titleClass]: (targets, delay, duration) =>
      gsap.from(targets, {
        duration,
        autoAlpha: 0,
        y: opts.distance,
        filter: 'blur(8px)',
        stagger: opts.stagger,
        ease: opts.ease,
        delay,
        scrollTrigger: { trigger: item, start: opts.start, once: opts.once },
      }),
    [opts.descClass]: (targets, delay, duration) =>
      gsap.from(targets, {
        duration,
        y: opts.distance,
        stagger: opts.stagger,
        ease: opts.ease,
        delay,
        scrollTrigger: { trigger: item, start: opts.start, once: opts.once },
      }),
  };

  gsap.utils.toArray(scopeEl.querySelectorAll(opts.selector)).forEach((item) => {
    const presetKey = Object.keys({ [opts.titleClass]: 1, [opts.descClass]: 1 }).find((cls) => item.classList.contains(cls));
    if (!presetKey) return;

    const delay = parseFloat(item.dataset.delay) || 0;
    const duration = parseFloat(item.dataset.splitDuration) || opts.duration;
    const mode = VALID_MODES.includes(item.dataset.splitMode) ? item.dataset.splitMode : opts.mode;
    const isDesc = presetKey === opts.descClass;

    const buildTween = (targets) => {
      const base = {
        duration,
        stagger: opts.stagger,
        ease: opts.ease,
        delay,
        y: opts.distance,
        scrollTrigger: { trigger: item, start: opts.start, once: opts.once },
      };
      return isDesc ? gsap.from(targets, base) : gsap.from(targets, { ...base, autoAlpha: 0, filter: 'blur(8px)' });
    };

    SplitText.create(item, {
      type: mode,
      ...(isDesc ? { mask: mode } : {}),
      autoSplit: true,
      onSplit: (self) => buildTween(self[mode]),
    });
  });

  return { refresh: () => ScrollTrigger.refresh() };
}


$(function(){
  //260713 기획전 템플릿 탭 고정
  if($('#htmlCustomTemplate').length){
    publisherCustomScrollEvent();

    // ══════════════════════════════════
    //  기획전 플로팅 네비게이션 관련 스크립트
    // ══════════════════════════════════
    const tabWrapper = document.querySelector('.html-custom-template-tab');
    const tabLinks = document.querySelectorAll('.html-custom-template-tab .layout-inner a');
    const tabHeight = tabWrapper.offsetHeight;

    function setActiveLink(link) {
      tabLinks.forEach((l) => l.classList.remove('active'));
      link.classList.add('active');
    }

    function clearActiveLinks() {
      tabLinks.forEach((l) => l.classList.remove('active'));
    }

    // ── 클릭 시 active 유지 + 스크롤 이벤트 잠시 무시 ──
    let isClickScrolling = false;
    let clickScrollTimer = null;

    tabLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        setActiveLink(this);

        isClickScrolling = true;
        clearTimeout(clickScrollTimer);

        if ('onscrollend' in window) {
          window.addEventListener(
            'scrollend',
            () => {
              isClickScrolling = false;
            },
            { once: true }
          );
        } else {
          clickScrollTimer = setTimeout(() => {
            isClickScrolling = false;
          }, 800);
        }
      });
    });

    // ── 스크롤에 따른 active 갱신 ──
    function updateActiveOnScroll() {
      if (isClickScrolling) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const triggerPoint = scrollTop + tabHeight; // 탭 높이만큼 보정된 기준선

      // 탭 자체의 sticky 여부 판단 (targetPrdList1 기준)
      const firstTarget = document.querySelector(tabLinks[0].getAttribute('href'));
      const firstOffset = firstTarget.offsetTop;
      const isSticky = scrollTop >= firstOffset;

      tabWrapper.classList.toggle('active', isSticky);

      if (!isSticky) {
        clearActiveLinks();
        return;
      }

      // 각 섹션의 offsetTop을 매번 새로 계산해서 현재 위치가 어느 섹션인지 판단
      let currentLink = tabLinks[0];

      tabLinks.forEach((link) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;

        if (triggerPoint >= target.offsetTop) {
          currentLink = link;
        }
      });

      setActiveLink(currentLink);
    }

    let ticking = false;
    // 페이지 스크롤 시 updateActiveOnScroll 실행
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateActiveOnScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    // 페이지 로드 시 초기 상태 반영
    window.addEventListener('load', updateActiveOnScroll);

    // 윈도우 리사이즈 시 offsetTop 조정
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateActiveOnScroll, 200);
    });
  }

  //260407 커스텀 필드 모션 추가
  if($('#htmlCustomPDP').length){
    $(window).on('load scroll', function(){
      $('.html-custom-motion-item').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.50) {
          $(this).addClass('active');
        }
      });
    });
  }

  if($('#collection250807').length){
        publisherCustomScrollEvent();

       var tabCollection250807 = $('#collection250807')
        tabCollection250807.on('click', 'a', function(event){
            event.preventDefault(); //prevents previous event
            smoothScrollCollection($(this.hash));
        });
        
        $(window).on('scroll', function(){
            tabStickyCollection();
        });
        tabStickyCollection();

        function tabStickyCollection(){
            var scrollTop = $(window).scrollTop();
            var chapter1 =  $('#as-skirt-campaign__block--1');
            var chapter2 =  $('#as-skirt-campaign__block--4');

            if((chapter1.offset().top - tabCollection250807.height() > scrollTop) || $('#main-collection-container').offset().top - tabCollection250807.height() < scrollTop){
                tabCollection250807.removeClass('active');
                 tabCollection250807.find('a').removeClass('active');
            } else {
                
                tabCollection250807.addClass('active');
                 if((chapter2.offset().top - tabCollection250807.height() > scrollTop))
                {   
                    tabCollection250807.find('a').removeClass('active');
                    tabCollection250807.find('a').eq(0).addClass('active');
                }
                else if ((chapter2.offset().top - tabCollection250807.height()) < scrollTop){
                        tabCollection250807.find('a').removeClass('active');
                        tabCollection250807.find('a').eq(1).addClass('active');
                }
            }

        }
        function smoothScrollCollection(target){
            $('body,html').animate({
                scrollTop: target.offset().top - tabCollection250807.height() + 10
            }, 600);
        }
  }
});

function publisherCustomScrollEvent(){
	var nowScrollTop = window.scrollY;
    var lastScrollTop;
    var delta = 5;
    var didScroll = false;
    var layout = $('#page-content');
    var topBannerHeight = 0;

    if(nowScrollTop < topBannerHeight){
        //Scroll top
        layout.addClass("top");
    }

    window.onscroll = function(e) {
        didScroll = true;
    };

    setInterval(function(){
        if(didScroll){
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled(){
        nowScrollTop = window.scrollY;

        if(Math.abs(lastScrollTop - nowScrollTop) <= delta){
            return;
        }

        if(nowScrollTop < topBannerHeight){
            //Scroll top
            layout.removeClass("up");
            layout.removeClass("down");
            layout.addClass("top");
        } else {
            layout.removeClass("top");

            if(lastScrollTop == undefined || nowScrollTop < lastScrollTop) {
                //Scroll up
                layout.removeClass("down");
                layout.addClass("up");
            } else if(nowScrollTop > lastScrollTop){
                //Scroll down
                layout.removeClass("up");
                layout.addClass("down");
            }
        }
        lastScrollTop = nowScrollTop;
    }
}
